import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getParticipantsStart } from "../../redux/quizathon/reducer";
import usePaginationWrapper from "../general/usePaginationWrapper";
import {
  selectIsLoadingQuizathonParticipants,
  selectQuizathonParticipants,
} from "../../redux/quizathon/selectors";

const useQuizathonParticipants = ({ quizathonId, fetchAll = false }) => {
  const dispatch = useDispatch();
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });
  const isLoading = useSelector(selectIsLoadingQuizathonParticipants);
  const quizathonParticipants = useSelector(selectQuizathonParticipants);
  const [selectSchool, setSelectSchool] = useState({ label: "", value: "" });
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const getQuizathonParticipants = useCallback(() => {
    dispatch(
      getParticipantsStart({
        quizathonId,
        keyword: debouncedSearchText,
        schoolId: selectSchool?.value,
        size: fetchAll ? -1 : limit,
        page: (page - 1) ,
      })
    );
  }, [
    dispatch,
    page,
    limit,
    quizathonId,
    debouncedSearchText,
    selectSchool.value,
    fetchAll,
  ]);

  useEffect(() => {
    getQuizathonParticipants();
  }, [getQuizathonParticipants, fetch]);

  useEffect(() => {
    if (quizathonParticipants) {
      setPageable({
        total_elements: quizathonParticipants?.count,
        total_pages: quizathonParticipants?.pages,
        number_of_elements: quizathonParticipants?.items?.length,
      });
    }
  }, [quizathonParticipants, setPageable]);

  return {
    quizathonParticipants,
    loadingQuizathonParticipants: isLoading,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
    setSelectSchool,
    selectSchool,
  };
};

export default useQuizathonParticipants;
